import { Box, CircularProgress, Typography, Alert } from "@mui/material";
import axios from "../api/axios";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../contexts/AuthProvider";
import { useTranslation } from 'react-i18next';

const KioskLoginPage = () => {
    const { t } = useTranslation('global');
    const { setAuth, setPersist } = useContext(AuthContext);
    const [loginError, setLoginError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [retryCount, setRetryCount] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        // Abilita persist per mantenere la sessione
        setPersist(true);
        localStorage.setItem("persist", true);

        // Effettua il login automatico
        const autoLogin = async () => {
            try {
                setLoginError(false);
                
                const loginData = { 
                    email: "info@casafrancescana.it", 
                    password: "123456", 
                    loginType: "customer" 
                };

                const response = await axios.post(
                    "/auth",
                    JSON.stringify(loginData),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }
                );

                if (response.data.accessToken) {
                    const accessToken = response.data.accessToken;
                    const userType = response.data.userType || 'customer';
                    const customerCode = response.data.customerCode;
                    const customerDatabase = response.data.customerDatabase;
                    const customer_id = response.data.customer_id;
                    const fullName = response.data.fullName;
                    const role = response.data.role;

                    const authData = {
                        email: "info@casafrancescana.it",
                        password: "123456",
                        accessToken,
                        userType,
                        customerCode,
                        customerDatabase,
                        customer_id,
                        fullName,
                        role
                    };

                    setAuth(authData);

                    // Reindirizza alla pagina TV Display
                    window.location.href = '/app-conviventi/tv-display';
                } else {
                    throw new Error("Login fallito");
                }
            } catch (error) {
                setLoginError(true);

                if (error.response?.status === 401) {
                    setErrorMessage(t('login.errors.invalidCredentials', 'Credenziali non valide'));
                } else if (error.response?.status === 500) {
                    setErrorMessage(t('login.errors.serverError', 'Errore del server'));
                } else if (error.code === 'ERR_NETWORK') {
                    setErrorMessage(t('login.errors.networkError', 'Impossibile connettersi al server'));
                } else {
                    setErrorMessage(t('login.errors.genericError', 'Errore durante il login'));
                }

                // Riprova dopo 5 secondi
                setTimeout(() => {
                    setRetryCount(prev => prev + 1);
                }, 5000);
            }
        };

        autoLogin();
    }, [retryCount]); // Riprova quando retryCount cambia

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                p: 4
            }}
        >
            {loginError ? (
                <Box sx={{ textAlign: 'center', color: 'white' }}>
                    <Alert severity="error" sx={{ mb: 3, fontSize: '1.2rem' }}>
                        {errorMessage}
                    </Alert>
                    <Typography variant="h6">
                        Nuovo tentativo tra 5 secondi... (Tentativo {retryCount + 1})
                    </Typography>
                    <CircularProgress sx={{ mt: 3, color: 'white' }} size={60} />
                </Box>
            ) : (
                <Box sx={{ textAlign: 'center', color: 'white' }}>
                    <CircularProgress sx={{ mb: 3, color: 'white' }} size={80} />
                    <Typography variant="h4" sx={{ fontWeight: 600 }}>
                        Connessione in corso...
                    </Typography>
                    <Typography variant="h6" sx={{ mt: 2, opacity: 0.9 }}>
                        Accesso automatico al sistema
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default KioskLoginPage;
